export function TranslationsFrancais() 
{
   return [
      {"id": "A name field is required","value":"Un champ Nom est requis"},   
      {"id": "Actions", "value": "Actes"},
      {"id": "Access key", "value": "Clé d'accès"},
      {"id": "Access token", "value": "Jeton d'accès"},
      {"id": "Account", "value": "Compte"},
      {"id": "Account ID", "value": "ID de compte"},
      {"id": "Account URL", "value": "URL du compte"},
      {"id": "Actions on incoming call", "value": "Actions lors d'un appel entrant"},
      {"id": "Add a custom integration", "value": "Ajouter une intégration personnalisée"},
      {"id": "Add line","value":"Ajouter une ligne"}, 
      {"id": "Add variable","value":"Ajouter une variable"}, 
      {"id": "Add new integration", "value": "Nouvelle integration"},
      {"id": "Add new script", "value": "Ajouter un script"},
      {"id": "Address","value":"Adresse"},    
      {"id": "API private key", "value": "Clé privée API"},
      {"id": "API public key", "value": "Clé publique API"},
      {"id": "API key", "value": "Clé API"},
      {"id": "API secret", "value": "Secret API"},
      {"id": "API URL", "value": "URL API"},
      {"id": "App token", "value": "Jeton d'application"},
      {"id": "Application", "value": "Application"},
      {"id": "$Application connection token received succesfully", "value": "$Application: jeton de connexion reçu avec succès"},
      {"id": "Application token", "value": "Jeton d'application"},      
      {"id": "At least one phone number field is required","value":"Au moins un champ de numéro de téléphone est requis"},   
      {"id": "Auto-execute", "value": "Exécution automatique"},
      {"id": "Automatic synchronization disabled", "value": "Synchronisation automatique désactivée"},
      {"id": "Automatic synchronization in", "value": "Synchronisation automatique dans"},
      {"id": "Automatically synchronize every day", "value": "Synchroniser automatiquement tous les jours"},
      {"id": "Automatically synchronize every week", "value": "Synchroniser automatiquement chaque semaine"},
      {"id": "BACK", "value": "PRÉCÉDENT"},
      {"id": "Call fields", "value": "Champs d'appel"},
      {"id": "Call notification", "value": "Notification d'appel"},
      {"id": "Caller name", "value": "Nom de l'appelant"},
      {"id": "Caller number", "value": "Numéro de l'appelant"},
      {"id": "Can be modified from computer", "value": "Modifiable depuis un ordinateur"},
      {"id": "Cancel", "value": "Annuler"},
      {"id": "cannot be configured in the Webconfigurator because the integration is client-based", "value": "Ne peut pas être configuré dans le Webconfigurateur car l'intégration est basée sur le client"},
      {"id": "cannot be configured in the Webconfigurator because the integration requires manual field configuration", "value": "Ne peut pas être configuré dans le Webconfigurateur car l'intégration requiert une configuration manuelle des champs"},
      {"id": "Cannot have more than one name field","value":"Il ne peut y avoir qu'un seul champ de nom"}, 
      {"id": "Check settings", "value": "Vérifier les paramètres"},
      {"id": "Checking CRM settings", "value": "Vérification des paramètres CRM en cours"},
      {"id": "Choose an integration template", "value": "Choisissez un préréglage d'application"},
      {"id": "Choose how you want to link to this application's recognition", "value": "Choisissez comment vous souhaitez lier à la reconnaissance de cette application"},
      {"id": "Choose CRM", "value": "Choix du CRM"},
      {"id": "Choose file","value":"Choisir un fichier"},
      {"id": "City","value":"Ville"},    
      {"id": "Client call notification", "value": "Notification d'appel client"},
      {"id": "Client ID", "value": "ID client"},
      {"id": "Client secret", "value": "Secret client"},
      {"id": "Cluster", "value": "Cluster"},
      {"id": "Company Id", "value": "ID de l'entreprise"},
      {"id": "Configuration OK","value":"Configuration OK"},
      {"id": "Configure", "value": "Configurer"},
      {"id": "Configure incoming call", "value": "Configuration"},  
      {"id": "Configure the $DatasourceName connection", "value": "Configurer la connexion avec $DatasourceName"},
      {"id": "Configure the action you want to perform", "value": "Configurer l'action que vous souhaitez exécuter"},
      {"id": "Configure the information you want the client to show when a caller is recognized from this set", "value": "Configurer les informations que le client doit afficher lorsqu'un appel est reconnu à partir de cet ensemble"},
      {"id": "Configure the recognition fields", "value": "Configurer les champs de reconnaissance"},
      {"id": "Configure your call notification","value":"Configurer les notifications d'appel sur un appel entrant"},  
      {"id": "Connect", "value": "Connecter"},
      {"id": "Country", "value": "Pays"},
      {"id": "Country code", "value": "Indicatif du pays"},
      {"id": "CRM configuration", "value": "Connexion au CRM"},
      {"id": "Current set: <count> phone number records", "value": "<count> numéros de téléphone dans le CRM"},
      {"id": "Custom field", "value": "Champ personnalisé"},
      {"id": "Custom phone fields", "value": "Champs téléphoniques personnalisés"},
      {"id": "Database", "value": "Base de données"},
      {"id": "Database country code", "value": "Indicatif téléphonique"},
      {"id": "Database ID", "value": "ID de la base de données"},
      {"id": "days", "value": "jours"},
      {"id": "<days> days ago", "value": "il y a <days> jours"},
      {"id": "Ddi name", "value": "Nom Ddi"},
      {"id": "Ddi number", "value": "Numéro Ddi"},
      {"id": "Delete", "value": "Supprimer"},
      {"id": "Destination","value":"Destination"},    
      {"id": "Device name", "value": "Nom de l'appareil"},
      {"id": "Device number", "value": "Extension"},
      {"id": "Disable", "value": "Désactiver"},
      {"id": "Do you really want to remove this integration?","value":"Voulez-vous vraiment supprimer cette intégration?"},
      {"id": "Do you really want to remove this script?","value":"Voulez-vous vraiment supprimer ce script?"},
      {"id": "Domain", "value": "Domaine"},
      {"id": "Done", "value": "Terminé"},
      {"id": "Edit","value":"Modifier"}, 
      {"id": "Editing not available in web app","value":"Modification non disponible dans l'application web"},
      {"id": "Email", "value": "Email"},
      {"id": "Enable", "value": "Activer"},
      {"id": "Enter the call field values to test the script with","value":"Saisissez les values des champs d'appel pour tester le script"},
      {"id": "<empty line>", "value": "<ligne vide>"},
      {"id": "Enter the import country code", "value": "Indicatif téléphonique du pays"},
      {"id": "Execute script", "value": "Exécuter"},
      {"id": "Failed to retrieve secure upload link","value":"Récupération du lien de mise à jour sécurisé a échoué"},
      {"id": "Failed to update the integration", "value": "La mise à jour de l'intégration a échoué"},
      {"id": "Failed to upload file","value":"Téléverser du fichier a échoué"},
      {"id": "File upload ok","value":"Téléverser du fichier ok"},
      {"id": "Finish", "value": "Terminer"},
      {"id": "Header","value":"Entête"}, 
      {"id": "here", "value": "ici"},
      {"id": "Home","value":"Accueil"},
      {"id": "hours", "value": "heure"},
      {"id": "<hours> hours ago", "value": "il y a <hours> heure"},
      {"id": "Include accounts", "value": "Ajouter des comptes"},
      {"id": "Include contacts", "value": "Ajouter des contacts"},
      {"id": "Include employees", "value": "Ajouter des employés"},
      {"id": "Include companies", "value": "Ajouter des entreprises"},
      {"id": "Include leads", "value": "Ajouter des prospects"},
      {"id": "Include organizations", "value": "Ajouter des organisations"},
      {"id": "Include people", "value": "Ajouter des personnes"},
      {"id": "Include users", "value": "Ajouter des utilisateurs"},
      {"id": "Incoming call","value":"Appel entrant"},   
      {"id": "InSite URL", "value": "URL InSite"},
      {"id": "Integrations", "value": "Intégrations"},
      {"id": "Integrations created with the desktop configurator can only be changed with the desktop configurator from the same computer.", "value": "Les intégrations créées avec le configurateur de bureau ne peuvent être modifiées qu'avec le configurateur de bureau depuis le même ordinateur"},
      {"id": "just now", "value": "à l'instant"},
      {"id": "Key", "value": "Clé"},
      {"id": "Language", "value": "Langue"},
      {"id": "Line","value":"Ligne"},
      {"id": "Loading...", "value": "Chargement en cours..."},
      {"id": "Location info", "value": "Localisation"},
      {"id": "minute", "value": "minute"},
      {"id": "minute ago", "value": "il y a une minute"},
      {"id": "minutes", "value": "minutes"},
      {"id": "<minutes> minutes ago", "value": "il y a <minutes> minutes"},
      {"id": "My Custom Script", "value": "Mon script personnalisé"},
      {"id": "Name","value":"Nom"}, 
      {"id": "Next", "value": "Suivant"},
      {"id": "Next synchronization could not be determined", "value": "La prochaine synchronisation ne peut pas être déterminée"},
      {"id": "No", "value": "Non"},
      {"id": "No file chosen","value":"Aucun fichier choisi"},  
      {"id": "No recognition has been configured", "value": "Aucune reconnaissance n'est configurée"},
      {"id": "No scripts have been configured", "value": "Aucun script n'est configuré"},
      {"id": "No settings are required. Click Next to continue", "value": "Aucun paramètre n'est requis. Cliquez sur Suivant pour continuer"},
      {"id": "Not synchronized yet", "value": "Pas encore synchronisé"},
      {"id": "OK", "value": "OK"},
      {"id": "Only synchronize manually", "value": "Synchroniser manuellement"},
      {"id": "Open application", "value": "Ouvrir l'application"},
      {"id": "Open webpage", "value": "Ouvrir la page web"},
      {"id": "Or, if your application is not in the list", "value": "Ou, si votre application n'est pas dans la liste"},
      {"id": "Organization", "value": "Organisation"},
      {"id": "Organization ID", "value": "ID de l'organisation"},
      {"id": "Organization number", "value": "Numéro d'organisation"},
      {"id": "Participant number", "value": "Numéro de participant"},
      {"id": "Password", "value": "Mot de passe"},
      {"id": "Perform an action in application", "value": "Exécuter une action dans l'application"},
      {"id": "Phone number","value":"Numéros de téléphone"}, 
      {"id": "phone number records", "value": "numéros de téléphone dans le CRM"},
      {"id": "Please download the Desktop Configurator", "value": "Téléchargez le Configurateur de bureau"},
      {"id": "predefined script", "value": "script prédéfini"},
      {"id": "Preview", "value": "Aperçu"},
      {"id": "Preview incoming call", "value": "Aperçu"},
      {"id": "Profit Services URL", "value": "URL Profit Services"},
      {"id": "Recognition", "value": "Reconnaissance"},
      {"id": "Recognition fields", "value": "Champs de reconnaissance"},
      {"id": "Recognition from", "value": "Connexion à"},
      {"id": "Reference", "value": "Référence"},
      {"id": "Region", "value": "Région"},
      {"id": "Remove this line","value":"Supprimer la ligne"},  
      {"id": "Requests per minute", "value": "Requêtes par minute"},  
      {"id": "Retrieving secure update link","value":"Récupération du lien de mise à jour sécurisé"},
      {"id": "Review","value":"Confirmation"},    
      {"id": "Review your integration", "value": "Examinez votre intégration"},
      {"id": "FINISH", "value": "TERMINER"},
      {"id": "NEXT", "value": "SUIVANT"},
      {"id": "Sandbox account", "value": "Compte sandbox"},
      {"id": "Security token", "value": "Jeton de sécurité"},
      {"id": "Screenpop URL", "value": "URL Screenpop"},
      {"id": "Script name", "value": "Nom du script"},
      {"id": "Script settings", "value": "Paramètres du script"},
      {"id": "Scripts", "value": "Scripts"},
      {"id": "Secret", "value": "Secrète"},
      {"id": "Secret key", "value": "Clé secrète"},
      {"id": "Select how the data should be synchronized", "value": "Sélectionnez comment les données doivent être synchronisées"},
      {"id": "Select your FileVine login", "value": "Sélectionnez votre connexion FileVine"},
      {"id": "Service URL", "value": "URL du service"},
      {"id": "Sign out", "value": "Se déconnecter"},
      {"id": "Signed in as", "value": "Connecté en tant que"},
      {"id": "Site", "value": "Site"},
      {"id": "Software key","value":"Clé logicielle"},
      {"id": "Sorry", "value": "Désolé"},
      {"id": "Source info", "value": "Source"},
      {"id": "Subdomain", "value": "Sous-domaine"},
      {"id": "Synchronization info", "value": "Synchronisation"},
      {"id": "Sync now", "value": "Synchroniser"},
      {"id": "System name", "value": "Nom du système"},
      {"id": "Tenant", "value": "Tenant"},
      {"id": "Test script", "value": "Tester"},
      {"id": "This application uses live search and does not need synchronization", "value": "Cette application utilise la recherche en direct et n'a pas besoin de synchronisation"},
      {"id": "The server will automatically execute script", "value": "Le serveur exécute automatiquement le script"},
      {"id": "This integration is disabled", "value": "Cette intégration est désactivée"},
      {"id": "This recognition is disabled", "value": "Cette reconnaissance est désactivée"},
      {"id": "This script is disabled", "value": "Ce script est désactivé"},
      {"id": "Token", "value": "Jeton"},
      {"id": "Token XML", "value": "Token XML"},
      {"id": "Unavailable in the Webconfigurator", "value": "Non disponible dans le Webconfigurateur"},
      {"id": "unknown type", "value": "type inconnu"},
      {"id": "Uploading file","value":"Téléverser du fichier"}, 
      {"id": "URL", "value": "URL"},
      {"id": "Use a team domain", "value": "Utilisez un domaine d'équipe"},
      {"id": "User", "value": "Utilisateur"},
      {"id": "Username", "value": "Nom d'utilisateur"},
      {"id": "Waiting for OAUTH verification", "value": "En attente de vérification OAUTH"},
      {"id": "Webpage", "value": "Page web"},
      {"id": "Web service username", "value": "Nom d'utilisateur du service web"},
      {"id": "Web service password", "value": "Mot de passe du service web"},
      {"id": "WebService URL", "value": "URL WebService"},
      {"id": "Welcome to the <branding_product> Webconfigurator for CRM integration", "value": "Bienvenue dans le Webconfigurateur <branding_product> pour l'intégration CRM"},
      {"id": "with caption", "value": "avec légende"},
      {"id": "With this tool you can manage your CRM integrations", "value": "Avec cet outil, vous pouvez gérer vos intégrations CRM"},
      {"id": "Yes", "value": "Oui"},
      {"id": "Your organization", "value": "Votre organisation"}
    ]      
}